export const buildQueryString = (params) => {
  return Object.entries(params)
    .filter(
      ([key, val]) => key && val !== null && val !== undefined && String(val),
    )
    .map(([key, val]) => `${key}=${val}`)
    .join("&")
}
